<div class="app-waiting" [ngClass]="{'appshow': _show, 'apphide': !_show, 'appdisabled': _disabled, 'appenabled': !_disabled}">
  <!--<img src="assets/common/images/wait/wait-dark.svg">-->
</div>